import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Typography, Button, TextField, IconButton } from "@material-ui/core";
import t from "../../../languages/pl";
import { isNullOrEmpty, isPassword } from '../../../utils/helpers';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const useStyles = theme => ({
    container: {
        display: 'flex',
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    textfield: {
        minWidth: 250,
        margin: theme.spacing(0.5)
    },
    passwordRequirements: {
        fontSize: '1rem',
        marginTop: theme.spacing(1),
        color: "red",
    },
    passwordsDoesntMatch: {
        fontSize: '1rem',
        marginTop: theme.spacing(1),
        color: "red",
    },
    title: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
});

const Adornment = ({ state, onClick }) => (
    <IconButton
        size="small"
        onClick={onClick}
    >
        {state ? <VisibilityOff /> : <Visibility />}
    </IconButton>
);

Adornment.propTypes = {
    state: PropTypes.bool,
    onClick: PropTypes.func
};

const ChangePassword = props => {
    const { classes, onSubmit } = props;
    const [showPassRequirements, setShowPassRequirements] = useState(false);
    const [passwordsDoesntMatch, setPasswordDoesntMatch] = useState(false);

    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmedPassword, setConfirmedPassword] = useState('');
    const [oldPasswordVisible, setOldPasswordVisible] = useState(false);
    const [newPasswordVisible, setNewPasswordVisible] = useState(false);
    const [confirmedPasswordVisible, setConfirmedPasswordVisible] = useState(false);

    const [disabledButton, setDisabledButton] = useState(true);

    useEffect(() => {
        if (newPassword !== confirmedPassword || oldPassword.length === 0 ){
            setDisabledButton(true);
        }

        if (oldPassword.length > 0 && newPassword.length > 0 && confirmedPassword.length > 0
            && isPassword(newPassword) && isPassword(confirmedPassword) && newPassword === confirmedPassword)
        {
            setPasswordDoesntMatch(false);
            setShowPassRequirements(false);
            setDisabledButton(false);
        } else {
            setDisabledButton(true);
        }
    }, [oldPassword, newPassword, confirmedPassword, showPassRequirements]);

    useEffect(() => {
        if(confirmedPassword === ""){
            setPasswordDoesntMatch(false);
        }
    }, [confirmedPassword]);

    const handleBlur = (e) => {
        if (!isPassword(e.target.value) && !isNullOrEmpty(e.target.value)) {
            setShowPassRequirements(true);
        } else {
            setShowPassRequirements(false);
        }
        if (!showPassRequirements && newPassword !== confirmedPassword) {
            setPasswordDoesntMatch(true);
        } else {
            setPasswordDoesntMatch(false);
        }
        if (confirmedPassword === "") {
            setPasswordDoesntMatch(false);
        }
    };
    const handleConfirm = () => {
        const state = {
            oldPassword: oldPassword,
            newPassword: newPassword,
            confirmPassword: confirmedPassword
        };
        onSubmit(state);
    };

    return (
        <React.Fragment>
            <div className={classes.title}>
                <Typography
                    variant="body1"
                    className={classes.passwordRequirements}
                    style={{ display: showPassRequirements ? "block" : "none" }}
                >
                    {t.passwordRequiredParameters}
                </Typography>

                <Typography
                    variant="body1"
                    className={classes.passwordsDoesntMatch}
                    style={{ display: (passwordsDoesntMatch && !showPassRequirements) ? "block" : "none" }}
                >
                   {t.passwordsDoesntMatch}
                </Typography>
            </div>
            <div className={classes.container}>
                <TextField
                    label={t.oldPassword}
                    className={classes.textfield}
                    type={oldPasswordVisible ? "text" : "password"}
                    onChange={(e) => setOldPassword(e.target.value)}
                    value={oldPassword}
                    InputProps={{
                        endAdornment: <Adornment state={oldPasswordVisible} onClick={() => setOldPasswordVisible(!oldPasswordVisible)} />
                    }}
                />
                <TextField
                    label={t.newPassword}
                    className={classes.textfield}
                    type={newPasswordVisible ? "text" : "password"}
                    onChange={(e) => setNewPassword(e.target.value)}
                    onBlur={handleBlur}
                    value={newPassword}
                    InputProps={{
                        endAdornment: <Adornment state={newPasswordVisible} onClick={() => setNewPasswordVisible(!newPasswordVisible)} />
                    }}
                />
                <TextField
                    label={t.confirmNewPassword}
                    className={classes.textfield}
                    type={confirmedPasswordVisible ? "text" : "password"}
                    onChange={(e) => setConfirmedPassword(e.target.value)}
                    onBlur={handleBlur}
                    value={confirmedPassword}
                    InputProps={{
                        endAdornment: <Adornment state={confirmedPasswordVisible} onClick={() => setConfirmedPasswordVisible(!confirmedPasswordVisible)} />
                    }}
                />
                <Button
                    variant="contained"
                    color="primary"
                    className={classes.textfield}
                    disabled={disabledButton}
                    onClick={handleConfirm}
                >
                    {t.confirm}
                </Button>
            </div>
        </React.Fragment>
    );
};

ChangePassword.propTypes = {
    classes: PropTypes.object,
    onSubmit: PropTypes.func
};

export default withStyles(useStyles)(ChangePassword);
